import React, { Component } from 'react';
import { Table, Grid, Row, Col, Form, FormGroup, ControlLabel, FormControl, ButtonToolbar, Button } from 'react-bootstrap';

import { PropTypes } from 'prop-types';

import { PaginationBuilder } from '../../PaginationBuilder';
import { PaginationHelper } from '../../helpers/PaginationHelper';
import { SearchHelper } from '../../helpers/SearchHelper';
import { FontStyleCommand } from '../commands/FontStyleCommand';
import { UploadCommand } from '../commands/UploadCommand';
import { LoadingSpinner } from '../../LoadingSpinner';
import { HandleMessage } from '../../HandleMessage';
import { HandleDialog } from '../../HandleDialog';
import { TitleRow } from '../../TitleRow';
import { SearchBar } from '../../SearchBar';
import { TableButton } from '../../TableButton';

export class FontsResources extends Component {
    static contextTypes = {
        selectApp: PropTypes.func
    }

    componentDidMount() {
        this.context.selectApp('bussched', false);
    }

    constructor(props) {
        super(props);

        this.state = {
            form: {
                file: null
            },
            styles: {
                file: null
            },
            table: {
                data: [],
                page: 1,
                totalPages: 1,
                elementsPerPage: 10,
                filter: ""
            },
            actions: {
                isLoading: true,
                isDeleting: false,
                isUploading: false
            },
            message: {
                show: false,
                message: undefined,
                style: undefined,
                icon: undefined,
                title: ""
            },
            dialog: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined,
                argument: undefined
            }
        };

        this.getData(false);
    }

    getData(resetData) {
        if (resetData) {
            const { actions, table } = this.state;

            table.data = [];
            actions.isLoading = true;

            this.setState({
                table: table,
                actions: actions
            });
        }

        const fontStyleCommand = new FontStyleCommand();
        fontStyleCommand.getAvailableFonts(
            (a) => this.listSuccessCallback(a),
            (a) => this.listErrorCallback(a)
        );
    }

    // ---------------------------

    listSuccessCallback(result) {
        const { table, actions } = this.state;
        const totalPages = PaginationHelper.getTotalPages(result.length, table.elementsPerPage);

        actions.isLoading = false;
        table.data = result;
        if (0 !== totalPages) {
            table.page = table.page > totalPages ? totalPages : table.page;
        }
        else {
            table.page = 1;
        }

        // Update table
        this.setState({
            table: table,
            actions: actions
        });
    }

    deleteSuccessCallback(message) {
        const { actions } = this.state;

        actions.isDeleting = false;

        this.setState({
            actions: actions,
            message: {
                show: true,
                message: message,
                style: "success",
                title: "Sucesso",
                icon: "ok"
            }
        });

        this.getData(true);
    }

    uploadSuccessCallback(message) {
        const { actions } = this.state;

        actions.isUploading = false;

        this.setState({
            actions: actions,
            message: {
                show: true,
                message: message,
                style: "success",
                title: "Sucesso",
                icon: "ok"
            }
        });

        this.getData(true);
    }

    listErrorCallback(message) {
        const { table, actions } = this.state;

        actions.isLoading = false;
        table.data = [];
        table.page = 1;

        this.setState({
            table: table,
            actions: actions,
            message: {
                show: true,
                message: message,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    operationErrorCallback(message) {
        const { actions } = this.state;

        actions.isDeleting = false;
        actions.isUploading = false;

        this.setState({
            actions: actions,
            message: {
                show: true,
                message: message,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    // -----------------------

    onChangePage(pageNumber) {
        const { table } = this.state;
        table.page = pageNumber;

        this.setState({
            table: table
        });
    }

    onChangeElementsPerPage(elementsPerPage) {
        const { table } = this.state;
        const totalPages = PaginationHelper.getTotalPages(table.data.length, elementsPerPage);

        table.elementsPerPage = elementsPerPage;
        if (0 !== totalPages) {
            table.page = table.page > totalPages ? totalPages : table.page;
        }
        else {
            table.page = 1;
        }

        this.setState({
            table: table
        });
    }

    onSearch(filter) {
        const { table } = this.state;

        table.filter = filter;

        this.setState({
            table: table
        });
    }

    onChangeFile(event, target) {
        const { form } = this.state;

        const uploadedFile = event.target.files[0];

        if (undefined !== uploadedFile) {
            form[target] = uploadedFile;

            this.setState({
                form: form
            });
        }
    }

    // ---------------------------

    onDeleteFont(font) {
        if (font.canBeDeleted) {
            this.setState({
                dialog: {
                    show: true,
                    title: "Aviso",
                    message: `Tem a certeza que pretende eliminar o tipo de letra "${font.name}"`,
                    style: "warning",
                    icon: "alert",
                    argument: {
                        fontName: font.name
                    }
                }
            });
        }
        else {
            this.setState({
                message: {
                    show: true,
                    message: "Não é possível eliminar este tipo de letra",
                    style: "danger",
                    title: "Erro",
                    icon: "remove"
                }
            });
        }
    }

    onUploadFont() {
        const { form, actions } = this.state;

        const styles = {
            file: null
        };

        if (null === form.file || undefined === form.file) {
            styles.file = "error";
        }

        if (null === styles.file) {
            actions.isUploading = true;

            const uploadCommand = new UploadCommand();
            uploadCommand.uploadFont(
                form,
                (a) => this.uploadSuccessCallback(a),
                (a) => this.operationErrorCallback(a)
            );

            form.file = null;
        }

        this.setState({
            form: form,
            styles: styles,
            actions: actions
        });
    }

    // -----------------------

    onExitMessage() {
        this.setState({
            message: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined
            }
        });
    }

    onExitDialog(isToExecute, argument) {
        const { actions } = this.state;

        if (isToExecute) {
            const fontStyleCommand = new FontStyleCommand();
            fontStyleCommand.deleteUploadedFont(
                argument.fontName,
                (a) => this.deleteSuccessCallback(a),
                (a) => this.operationErrorCallback(a)
            );

            actions.isDeleting = true;
        }

        this.setState({
            actions: actions,
            dialog: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined,
                argument: undefined
            }
        });
    }

    // ---------------------------

    renderForm(isUploading, styles) {
        if (isUploading) {
            return (
                <LoadingSpinner />
            );
        }

        return (
            <div>
                <Form>
                    <FormGroup
                        controlId="formDataFile"
                        validationState={styles.file} >
                        <ControlLabel>Carregar Tipo de Letra</ControlLabel>
                        <FormControl
                            type="file"
                            placeholder="Tipo de Letra"
                            onChange={(e) => this.onChangeFile(e, "file")} />
                    </FormGroup>
                </Form>

                <ButtonToolbar>
                    <Button
                        bsStyle="default"
                        className="margin-left-15"
                        onClick={() => this.onUploadFont()} >
                        CARREGAR
                    </Button>
                </ButtonToolbar>
            </div>
        );
    }

    renderTable(isWaiting) {
        if (isWaiting) {
            return (
                <LoadingSpinner />
            )
        }

        const { table } = this.state;

        const dataFiltered = SearchHelper.search({
            filter: table.filter,
            data: table.data,
            fields: ["name"]
        });
        const totalPages = PaginationHelper.getTotalPages(dataFiltered.length, table.elementsPerPage);
        const activePage = totalPages < table.page ? totalPages : table.page;
        const partialData = dataFiltered.slice((activePage - 1) * table.elementsPerPage, activePage * table.elementsPerPage);

        return (
            <Grid fluid>
                <Row>
                    <Col sm={12}>
                        <Table responsive striped hover style={{ marginTop: 10 }}>
                            <thead>
                                <tr>
                                    <th>Nome</th>
                                    <th>&nbsp;</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    partialData.map((data, idx) =>
                                        <tr key={`layout-${idx}`}>
                                            <td>{data.name}</td>
                                            <td>{this.renderDeleteButton(data)}</td>
                                        </tr>
                                    )
                                }
                            </tbody>
                        </Table>

                        <PaginationBuilder
                            currentPage={table.page}
                            elementsPerPage={table.elementsPerPage}
                            dataLength={dataFiltered.length}
                            onChangePage={(a) => this.onChangePage(a)}
                            onChangeElementsPerPage={(a) => this.onChangeElementsPerPage(a)} />
                    </Col>
                </Row>
            </Grid>
        );
    }

    renderDeleteButton(font) {
        if (!font.canBeDeleted) {
            return (
                <p>&nbsp;</p>
            );
        }

        return (
            <ButtonToolbar className="pull-right">
                <TableButton icon="icon-trash" title="Eliminar" onClick={() => this.onDeleteFont(font)} />
            </ButtonToolbar>
        );
    }

    render() {
        const { actions, styles, message, dialog } = this.state;

        return (
            <div>
                <TitleRow title="Tipos de Letra" showSeparator={true}>
                    <Col className="padding-0" xs={12} sm={12} md={8} mdOffset={4}>
                        <div className="search-bar">
                            <SearchBar onSearch={(a) => this.onSearch(a)} />
                        </div>
                    </Col>
                </TitleRow>
                <Grid className="margin-top-15" fluid>
                    <Row>
                        <Col sm={12}>
                            {this.renderForm(actions.isUploading, styles)}
                        </Col>
                    </Row>
                </Grid>

                {this.renderTable(actions.isLoading || actions.isDeleting)}

                <HandleMessage
                    title={message.title}
                    message={message.message}
                    style={message.style}
                    icon={message.icon}
                    show={message.show}
                    onHide={() => this.onExitMessage()} />

                <HandleDialog
                    show={dialog.show}
                    title={dialog.title}
                    message={dialog.message}
                    style={dialog.style}
                    icon={dialog.icon}
                    argument={dialog.argument}
                    onExit={(a, b) => this.onExitDialog(a, b)} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/bussched/resources/FontsResources.js